import gsap from 'gsap';
import { q1O, s0 } from '../util/nE';
import SplitText from 'gsap/SplitText';
import state from '../state';
gsap.registerPlugin(SplitText);

class WordCard {
  constructor($el) {
    this.el = $el;
  }

  init() {
    this.isXl = false;
    const mm = gsap.matchMedia();
    mm.add(state.queries.xl, () => {
      this.isXl = true;
    });

    if (this.isXl) {
      this.buildHover();
    }
  }

  handleMouseEnter() {
    if (this.titles) {
      this.onMouseEnter(this.titles);
    }
  }

  handleMouseLeave() {
    if (!this.el.classList.contains('is-active') && this.titles) {
      this.onMouseLeave(this.titles);
    }
  }

  buildHover() {
    const all = this.el.querySelectorAll('.work-card__title');
    const first = all[0];
    const last = all[1];

    this.splitFirst = this.buildSplitText(first);
    this.splitLast = this.buildSplitText(last);

    this.titles = this.buildTitlesAnimation(this.splitFirst, this.splitLast);

    this.el.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.el.addEventListener('mouseleave', this.handleMouseLeave.bind(this));

    if (this.el.classList.contains('is-active')) {
      this.handleMouseEnter();
    }
  }

  buildTitlesAnimation(splitFirst, splitLast) {
    if (!splitLast || !splitFirst) return;
    const stag1 = (40 / splitFirst.chars.length) * 0.01;
    const tl = gsap.timeline({
      paused: true,
    });
    tl.set(splitLast.elements[0], { autoAlpha: 1 });
    tl.to(
      splitFirst.chars,
      {
        yPercent: -50,
        stagger: stag1,
        rotationX: -90,
        duration: 0.25,
      },
      0
    );
    tl.fromTo(
      splitLast.chars,
      {
        yPercent: 50,
        rotationX: 90,
      },
      {
        yPercent: 0,
        rotationX: 0,
        stagger: stag1,
        duration: 0.35,
        color: '#005df8',
      },
      0
    );

    return tl;
  }

  onMouseEnter(tl) {
    tl.play();
  }

  onMouseLeave(tl) {
    tl.play().reverse();
  }

  buildSplitText(el) {
    if (!el) {
      return;
    }
    const split = new SplitText(el, {
      type: 'chars, words, lines',
      linesClass: 's-line u-t overflow-hidden',
      autoSplit: true,
      onSplit: self => {
        if (self.elements[0].classList.contains('work-card__title--inner')) {
          this.splitLast = self;
        } else {
          this.splitFirst = self;
        }
        this.titles = this.buildTitlesAnimation(
          this.splitFirst,
          this.splitLast
        );
      },
    });

    return split;
  }

  destroy() {
    this.el.removeEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.el.removeEventListener('mouseleave', this.handleMouseLeave.bind(this));
    //  window.removeEventListener('resize', this.handleResize.bind(this));
  }
}

export default WordCard;



//////////////////
// WEBPACK FOOTER
// ./scripts/components/WorkCard.js
// module id = 72
// module chunks = 0